module.exports = __webpack_public_path__ + "media/decathlon.3597532a.mp4";